import { Pipe, PipeTransform } from '@angular/core';

/* === Format Phone Number Custom Pipe ===
 * Take in phone number string
 * Convert it to be "(###) ###-####"
 */

@Pipe({ name: 'formatPhone' })

export class FormatPhonePipe implements PipeTransform {
    transform(phoneString: string): string {

        let formattedPhone = '';

        if (phoneString !== '') {
            const areaCodeNum = phoneString.slice(0, 3);
            const secondSectionNum = phoneString.slice(3, 6);
            const lastSectionNum = phoneString.slice(6);

            formattedPhone = `(${areaCodeNum}) ${secondSectionNum}-${lastSectionNum}`;
        }

        return formattedPhone;
    }
}
